module.exports = __webpack_public_path__ + "media/luxury-2026/glassy-kitchen-960-474c84f6.jpg";